import withParams from "@src/components/widgets/HOC/withParams";
import React from "react";
import { WidgetTemplateComponentType } from "@src/interface/Widget";
import { ILandingStandardWidgetEngagementsParams } from "../interface";
import LandingEngagements from "design-system/src/Components/WidgetPart/LandingEngagements/LandingEngagements";
import useEngagements from "../hooks/useEngagements";

const LandingStandardEngagements: WidgetTemplateComponentType =
  withParams<ILandingStandardWidgetEngagementsParams>((props) => {
    const { p, params } = props;

    const { prepareEngagements } = useEngagements(params);

    return (
      <LandingEngagements
        title={p("title") + ""}
        highlightedTitle={p("subtitle")}
        description={p("description")}
        engagements={prepareEngagements()}
      />
    );
  });

export default LandingStandardEngagements;
